import { InjectionToken } from '@angular/core';
import type { UrlTree } from '@angular/router';

/**
 * Contrato de sesión que permite ejecutar Sites Builder con autenticación propia
 * o con la sesión de un host sin acoplar el dominio al mecanismo de login.
 */
export interface SitesBuilderAuthSession {
  /** Devuelve la cabecera Authorization completa mientras la sesión sea válida. */
  getAuthorizationHeader(): string | undefined;
  /** Indica si existe una sesión administrativa vigente. */
  isAuthenticated(): boolean;
  /** Resuelve la navegación segura cuando una ruta privada no tiene sesión. */
  redirectUnauthenticated(returnUrl: string): UrlTree;
  /** Cierra la sesión propietaria del contexto actual. */
  logout(): void | Promise<void>;
}

/** Sesión administrativa activa para el contexto standalone o embebido. */
export const SITES_BUILDER_AUTH_SESSION =
  new InjectionToken<SitesBuilderAuthSession>('Sites Builder Auth Session');
